// This is the scss entry file
import "../styles/index.scss";

import $ from 'jquery';
// const $ = require('jquery');
global.$ = global.jQuery = $;
window.$ = window.jQuery = $;

// We can import Bootstrap JS instead of the CDN link, if you do not use
// Bootstrap, please feel free to remove it.
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle";
window.bootstrap = bootstrap;
import "bootstrap-datepicker/dist/js/bootstrap-datepicker.min";
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.pl.min";

import anime from 'animejs';
window.anime = global.anime = anime;
//import "jquery-toasts/dist/js/jquery-toasts.min";
//import "jquery-validation/dist/jquery.validate.min.js"
import "jquery-toast-plugin"
import "jquery-tags-input/dist/jquery.tagsinput.min";
import "jquery.repeater/jquery.repeater.min";
import "perfect-scrollbar";
import "select2";
import "moment/dist/locale/pl";
import "moment/dist/moment";
import "inputmask";
import "dragula";


// import select2 from 'select2';


const moment = require('moment');
window.moment = moment;

// We can import other JS file as we like
//import "../components/add_voice";
// import "./plusadmin/ace";
// import "./plusadmin/alerts";
// import "./plusadmin/avgrund";
// import "./plusadmin/bootstrap-table";
// import "./plusadmin/bt-maxLength";
// import "./plusadmin/c3";
// import "./plusadmin/calendar";
// import "./plusadmin/chart";
// import "./plusadmin/chartist";
// import "./plusadmin/circle-progress";
// import "./plusadmin/clipboard";
// import "./plusadmin/codeEditor";
// import "./plusadmin/codemirror";
// import "./plusadmin/context-menu";
// import "./plusadmin/cropper";
// import "./plusadmin/dashboard";
// import "./plusadmin/data-table";
// import "./plusadmin/db";
// import "./plusadmin/desktop-notification";
//import "./plusadmin/dragula";
// import "./plusadmin/dropify";
// import "./plusadmin/dropzone";
// import "./plusadmin/editorDemo";
// import "./plusadmin/file-upload";
// import "./plusadmin/flot-chart";
// import "./plusadmin/form-addons";
// import "./plusadmin/form-repeater";
// import "./plusadmin/form-validation";
// import "./plusadmin/formpickers";
// import "./plusadmin/google-charts";
// import "./plusadmin/google-maps";
import "./plusadmin/hoverable-collapse";
// import "./plusadmin/iCheck";
// import "./plusadmin/inputmask";
// import "./plusadmin/ion-range-slider";
// import "./plusadmin/jq.tablesort";
// import "./plusadmin/jquery-file-upload";
import "./plusadmin/jquery.cookie";
// import "./plusadmin/js-grid";
// import "./plusadmin/js-tree";
// import "./plusadmin/just-gage";
// import "./plusadmin/light-gallery";
// import "./plusadmin/listify";
// import "./plusadmin/login";
// import "./plusadmin/mapael";
// import "./plusadmin/mapael_example_1";
// import "./plusadmin/mapael_example_2";
// import "./plusadmin/maps";
import "./plusadmin/misc";
// import "./plusadmin/modal-demo";
// import "./plusadmin/morris";
// import "./plusadmin/no-ui-slider";
import "./plusadmin/off-canvas";
// import "./plusadmin/owl-carousel";
// import "./plusadmin/paginate";
// import "./plusadmin/popover";
// import "./plusadmin/profile-demo";
// import "./plusadmin/progress-bar";
// import "./plusadmin/rickshaw";
//import "./plusadmin/select2";
// import "./plusadmin/settings";
// import "./plusadmin/sparkline";
// import "./plusadmin/tablesorter";
// import "./plusadmin/tabs";
// import "./plusadmin/tight-grid";
// import "./plusadmin/toastDemo";
// import "./plusadmin/todo";
// import "./plusadmin/todolist";
// import "./plusadmin/tooltips";
// import "./plusadmin/typeahead";
// import "./plusadmin/widgets";
// import "./plusadmin/wizard";
// import "./plusadmin/x-editable";
import "./main";
import "./eventSongs";
import "./invitation_queue";
import "./tagSongs";
import "./attendance_thresholds";
import "./list_check";
import "./announcements";
import "./main_page_ajax";
import "./songVoices";
import "./statistics";
import "./eventPage";

const closeAllDropdowns = () => {
    document.querySelectorAll('.dropdown-menu.show').forEach((menu) => {
        menu.classList.remove('show');
    });

    document.querySelectorAll('[data-bs-toggle="dropdown"][aria-expanded="true"]').forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false');
    });
};

const initializeDropdowns = () => {
    document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((toggle) => {
        if (toggle.dataset.bootstrapDropdownInitialized === 'true') {
            return;
        }

        if (window.bootstrap && typeof window.bootstrap.Dropdown !== 'undefined') {
            window.bootstrap.Dropdown.getOrCreateInstance(toggle);
            toggle.dataset.bootstrapDropdownInitialized = 'true';
            return;
        }

        toggle.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const menu = toggle.nextElementSibling;
            if (!menu || !menu.classList.contains('dropdown-menu')) {
                return;
            }

            const shouldOpen = !menu.classList.contains('show');
            document.querySelectorAll('.dropdown-menu.show').forEach((openMenu) => {
                if (openMenu !== menu) {
                    openMenu.classList.remove('show');
                }
            });

            document.querySelectorAll('[data-bs-toggle="dropdown"][aria-expanded="true"]').forEach((openToggle) => {
                if (openToggle !== toggle) {
                    openToggle.setAttribute('aria-expanded', 'false');
                }
            });

            menu.classList.toggle('show', shouldOpen);
            toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
        });

        toggle.dataset.bootstrapDropdownInitialized = 'true';
    });
};

document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) {
        return;
    }

    const insideToggle = target.closest('[data-bs-toggle="dropdown"]');
    const insideMenu = target.closest('.dropdown-menu');

    if (!insideToggle && !insideMenu) {
        closeAllDropdowns();
    }
});

document.addEventListener('DOMContentLoaded', initializeDropdowns);
initializeDropdowns();
import "./userPage";
import "./ensemblePage";
import "./pollCreation";
import "./pollActions";
import "./recipient-access-manager";
import "./mailingListManager";
import "./exportData";
import "./analytics";
import "./mediaList";

//import "./eventCalendar";

window.document.addEventListener("DOMContentLoaded", function () {
//  window.console.log("dom ready 1");
});
